<template>
  <div id="mySupersuProList">
    <div>
      <div class="allDl m_t_20 d_flex" style="position:relative">
        <dl class="allDl_width30 allDl_span60" style="width: 80%">
          <dd>
            <span style="width: 80px">下游系统名称:</span>
            <div style="width: calc(100% - 84px)">
              <input v-model="postData.GroupName" type="text" class="allInput"/>
            </div>
          </dd>
          <dt style="width: auto;">
            <button @click="getAllSerch()" class="suerButton"><i class="icon iconfont iconsousuo" style="font-size: 14px"></i><span class="m_l_5">搜索</span></button>
          </dt>
        </dl>
        <div>
          <button @click="toUrl(0)" class="addButton"><i class="el-icon-plus"></i><span class="m_l_5">新建</span></button>
        </div>
      </div>
      <div style="max-height: calc(100vh - 270px);overflow: auto">
        <table class="allTable" cellspacing="0">
          <thead>
          <tr>
            <th>下游系统名称</th>
            <th>描述</th>
            <th>最近更新时间</th>
            <th>最近更新人</th>
            <th>操作</th>
          </tr>
          </thead>
          <tbody>
          <tr :key="index" v-for="(item, index) in myAllList">
            <td>{{ item.name }}</td>
            <td>{{ item.describe}}</td>
            <td>{{ $commonJs.returnDate(item.lastModifyTime, 'YYMMDD') }}</td>
            <td>{{ item.lastModifyName }}</td>
            <td class="colorYellowF36A20" width="60">
              <div class="d_flex">
                <span class="c_p" @click="toUrl(item)">编辑</span>
                <span @click="allDelt(item)" class="colorDele c_p">删除</span>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <page :totalCount="totalCount" v-if="totalPage !== 0" v-on:on-getList="getAllList($event)" :totalPage="totalPage" :page="page" :numPage="1"></page>
    </div>
  </div>
</template>

<script>
export default {
  name: 'myAPIGateList',
  data () {
    return {
      totalPage: 0,
      totalCount: 0,
      page: 1,
      postData: {
        GroupName: '',
        pageIndex: 1,
        pageSize: window.localStorage.getItem(window.location.hash + 'gyspage') || this.$commonJs.commonPageSize
      },
      serchData: {
        GroupName: '',
        pageIndex: 1,
        pageSize: window.localStorage.getItem(window.location.hash + 'gyspage') || this.$commonJs.commonPageSize
      },
      myAllList: [],
      myNewData: {
        id: 0,
        name: '',
        describe: ''
      },
      superId: 0
    }
  },
  created () {
    this.getAllList(1)
  },
  mounted () {
  },
  methods: {
    getAllSerch () {
      this.serchData = JSON.parse(JSON.stringify(this.postData))
      this.getAllList(1)
    },
    getAllList (page) {
      let data = JSON.parse(JSON.stringify(this.serchData))
      if (this.serchData.GroupName === '') {
        delete data['GroupName']
      }
      data.pageIndex = page
      let url = this.$commonJs.returnQuery('/api/Role/GetAllGateApi', data)
      this.$axiox.get(url).then(msg => {
        this.myAllList = msg.datas || []
        this.page = page
        this.totalPage = Math.ceil(msg.total / this.serchData.pageSize)
        this.totalCount = msg.total
      })
    },
    toUrl (item) {
      this.$router.push({
        name: 'myAPIGate',
        query: {
          formId: (item && item.id) || this.superId
        }
      })
    },
    allDelt (item) {
      this.$commonJs.doubleComfirm({
        content: '是否删除该下游系统？',
        successFun: msg => {
          this.$axiox.get('/api/Role/DeleteGateApi?gateid=' + item.id).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '删除成功',
              stayTime: 5
            })
            this.getAllList(this.page)
          })
        },
        errorFun: msg => {
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/mySystemMessager/myAPIGateList.vue